import FeedMaterialsProductionCenterData from "../../../../src/components/feed-materials-production-center-data";
import * as React from 'react';
export default {
  FeedMaterialsProductionCenterData,
  React
};